"use client";

import { c as _c } from "react/compiler-runtime";
import { useSearchPageMapData } from "@/hooks/search";
import { useDataFetchOrchestrator } from "@/hooks/use-data-fetch-orchestrator";
import { useUrlFilters } from "@/hooks/use-url-filters";
import { Bounds } from "@/types/map";
import { cn } from "@/utils/cn";
import { transformFilters } from "@/utils/search/transform-filters";
import { useMap } from "@vis.gl/react-google-maps";
import { ButtonHTMLAttributes } from "react";
import { baseClasses, unselectedClasses } from "..";
interface SearchAreaButtonOverlayProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  isLoading: boolean;
  setSelectedIndex: (index: number) => void;
  onSearchAreaClick?: () => void;
}
export const SearchAreaButton = function SearchAreaButton(t0) {
  const $ = _c(29);
  let isLoading;
  let onSearchAreaClick;
  let props;
  if ($[0] !== t0) {
    const {
      isLoading: t1,
      onSearchAreaClick: t2,
      setSelectedIndex: _setSelectedIndex,
      ...t3
    } = t0;
    isLoading = t1;
    onSearchAreaClick = t2;
    props = t3;
    $[0] = t0;
    $[1] = isLoading;
    $[2] = onSearchAreaClick;
    $[3] = props;
  } else {
    isLoading = $[1];
    onSearchAreaClick = $[2];
    props = $[3];
  }
  const mode = useSearchPageMapData(_temp);
  const fetchMapData = useSearchPageMapData(_temp2);
  const fetchNearByProjects = useSearchPageMapData(_temp3);
  let t1;
  if ($[4] !== fetchMapData || $[5] !== fetchNearByProjects || $[6] !== mode) {
    t1 = {
      mode,
      fetchMapData,
      fetchNearByProjects
    };
    $[4] = fetchMapData;
    $[5] = fetchNearByProjects;
    $[6] = mode;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const {
    orchestrateFetch
  } = useDataFetchOrchestrator(t1);
  const {
    filters,
    setFilters
  } = useUrlFilters();
  const bounds = useSearchPageMapData(_temp4);
  const map = useMap();
  let t2;
  if ($[8] !== bounds || $[9] !== filters || $[10] !== map || $[11] !== onSearchAreaClick || $[12] !== orchestrateFetch || $[13] !== setFilters) {
    t2 = () => {
      onSearchAreaClick?.();
      if (!bounds) {
        return;
      }
      const currentZoom = map?.getZoom();
      const {
        filtersForGraphQL,
        newFilters
      } = transformFilters({
        filters,
        selectedLocationId: "custom",
        mapBounds: map?.getBounds()?.toJSON?.() as Bounds,
        mapZoom: currentZoom,
        from: "search-area"
      });
      setFilters(newFilters, {
        useReplaceState: true
      });
      orchestrateFetch({
        filters: newFilters,
        filtersForGraphQL,
        map
      });
    };
    $[8] = bounds;
    $[9] = filters;
    $[10] = map;
    $[11] = onSearchAreaClick;
    $[12] = orchestrateFetch;
    $[13] = setFilters;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  const handleSearchAreaClick = t2;
  let t3;
  if ($[15] !== handleSearchAreaClick) {
    t3 = event => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        handleSearchAreaClick();
      }
    };
    $[15] = handleSearchAreaClick;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  const handleKeyDown = t3;
  let t4;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = cn(baseClasses, unselectedClasses, "border-black/40 border-1");
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  let t5;
  if ($[18] !== isLoading) {
    t5 = isLoading && {
      "aria-busy": "true"
    };
    $[18] = isLoading;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] !== isLoading) {
    t6 = isLoading ? <><div className="w-3 h-3 border-2 border-white/30 border-t-white rounded-full animate-spin" /><span>Searching...</span></> : <span>Search this area</span>;
    $[20] = isLoading;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== handleKeyDown || $[23] !== handleSearchAreaClick || $[24] !== isLoading || $[25] !== props || $[26] !== t5 || $[27] !== t6) {
    t7 = <button onClick={handleSearchAreaClick} onKeyDown={handleKeyDown} disabled={isLoading} className={t4} aria-label="Search this area" {...t5} {...props}>{t6}</button>;
    $[22] = handleKeyDown;
    $[23] = handleSearchAreaClick;
    $[24] = isLoading;
    $[25] = props;
    $[26] = t5;
    $[27] = t6;
    $[28] = t7;
  } else {
    t7 = $[28];
  }
  return t7;
};
function _temp(state) {
  return state.mode;
}
function _temp2(state_0) {
  return state_0.fetchMapData;
}
function _temp3(state_1) {
  return state_1.fetchNearByProjects;
}
function _temp4(state_2) {
  return state_2.bounds;
}